module.exports = __webpack_public_path__ + "static/media/nft-card-district.06f2f9b1.png";